// src/utils/clipboard.ts - Clipboard utilities
export class ClipboardService {
  public static async copy(text: string): Promise<boolean> {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
        return true;
      } else {
        // Fallback for older browsers
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        const successful = document.execCommand("copy");
        document.body.removeChild(textArea);

        return successful;
      }
    } catch (error) {
      console.error("Failed to copy text to clipboard:", error);
      return false;
    }
  }

  public static async paste(): Promise<string | null> {
    try {
      if (navigator.clipboard && navigator.clipboard.readText) {
        return await navigator.clipboard.readText();
      } else {
        // Fallback not available for reading clipboard in older browsers
        return null;
      }
    } catch (error) {
      console.error("Failed to read text from clipboard:", error);
      return null;
    }
  }
}
